import { useConfigLoadingParamBuilder, useObjectConfigLoader } from '../../../hooks/useObjectConfigLoader';
import { ObjectTypes } from '../../../utils/constants';
import FilterConfigSkeleton from '../../LoadingIndicator/FilterConfigSkeleton';
import CommonSearchFilter from '../../CommonSearchFilter/CommonSearchFilter';
// import { globalSearchActions } from '../store/slices/globalSearchSlice';
import { loadSavedFilterStoreActionHandler } from '../store/actions/global-actions';

const FilterSettingObjectType = ObjectTypes.SearchFilter_BunkerResults;

const Content = () => {
  const configLoadingParam = useConfigLoadingParamBuilder(FilterSettingObjectType);
  const { isLoading: isFilterConfigLoading } = useObjectConfigLoader(configLoadingParam);
  // const configuredFilters = [
  //   {
  //     Text: 'Client',
  //     Field: 'Client',
  //     Order: 1,
  //     Visible: true,
  //     ControlType: 'ClientAutoComplete',
  //     ServerFilter: true,
  //     xs: 12,
  //     sm: 12,
  //     md: 6,
  //     lg: 4
  //   },
  //   {
  //     Text: 'Report Address',
  //     Field: 'ReportAddress',
  //     Order: 2,
  //     Visible: true,
  //     SearchType: 'addresses',
  //     ControlType: 'RemoteDataAutoComplete',
  //     ServerFilter: true,
  //     xs: 12,
  //     sm: 12,
  //     md: 6,
  //     lg: 4
  //   },
  //   {
  //     Text: 'Scenario',
  //     Field: 'Scenario',
  //     Order: 3,
  //     Visible: true,
  //     SearchType: 'scenarios',
  //     ControlType: 'RemoteDataAutoComplete',
  //     ServerFilter: true,
  //     xs: 12,
  //     sm: 12,
  //     md: 6,
  //     lg: 4
  //   },
  //   // {
  //   //   Text: 'Project',
  //   //   Field: 'Project',
  //   //   Order: 3,
  //   //   Visible: true,
  //   //   SearchType: 'project',
  //   //   ControlType: 'RemoteDataAutoComplete',
  //   //   ServerFilter: true,
  //   //   xs: 12,
  //   //   sm: 12,
  //   //   md: 6,
  //   //   lg: 4
  //   // },
  //   // {
  //   //   Text: 'PO',
  //   //   Field: 'PO',
  //   //   Order: 4,
  //   //   Visible: true,
  //   //   SearchType: 'po',
  //   //   ControlType: 'RemoteDataAutoComplete',
  //   //   ServerFilter: true,
  //   //   xs: 12,
  //   //   sm: 12,
  //   //   md: 6,
  //   //   lg: 4
  //   // },
  //   // {
  //   //   Text: 'Site Location',
  //   //   Field: 'SiteLocation',
  //   //   Order: 5,
  //   //   Visible: true,
  //   //   SearchType: 'location',
  //   //   ControlType: 'RemoteDataAutoComplete',
  //   //   ServerFilter: true,
  //   //   xs: 12,
  //   //   sm: 12,
  //   //   md: 6,
  //   //   lg: 4
  //   // }
  // ];

  return (
    <>
      {isFilterConfigLoading
        ? <FilterConfigSkeleton />
        : (
          <CommonSearchFilter
            elevation={6}
            reduxStateName="globalSearch"
            FilterSettingObjectType={ObjectTypes.SearchFilter_Global}
            SearchSavedUserFilter={ObjectTypes.UserSearchUserFilter}
            // sliceActions={globalSearchActions}
            loadSavedFilter={loadSavedFilterStoreActionHandler}
            disableSearch
          />
        )}
    </>
  );
};

export default Content;
